import React from 'react';

import styles from './personalDetailsStyles';

const PersonalDetails = ({ userProfile }) => {
  const {
    hometown,
    investmentHero,
    favoriteInvestmentBook,
    investingStyle,
    languagesSpoken
  } = userProfile;
  const items = [
    { label: 'Hometown', value: hometown },
    { label: 'Investment Hero', value: investmentHero },
    { label: 'Favorite Investment Book', value: favoriteInvestmentBook },
    { label: 'Investing Style', value: investingStyle },
    { label: 'Languages Spoken', value: languagesSpoken }
  ].filter(item => item.value);
  return (
    <div>
      <ul className={styles.personalDetailsList}>
        {items.map((item, idx) => (
          <li key={idx}>
            <h4>{item.label}</h4>
            <span>{item.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PersonalDetails;
